import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ProblemLayout from '../../components/ProblemLayout';
import { stackQueueProblems } from '../../data/practice/stackQueueProblems';

const StackQueueProblem: React.FC = () => {
  const { problemId } = useParams<{ problemId: string }>();
  const problem = stackQueueProblems.find(p => p.id === problemId);
  const [code, setCode] = useState(problem?.starterCode || '');

  if (!problem) {
    return <div>Problem not found</div>;
  }

  return (
    <ProblemLayout
      title={problem.title}
      difficulty={problem.difficulty}
      tags={problem.tags}
      description={problem.description}
      hints={problem.hints}
      code={code}
      onCodeChange={setCode}
      onResetCode={() => setCode(problem.starterCode)}
      backUrl="/practice/stack-queue"
      problemId={problemId || ''}
    />
  );
};

export default StackQueueProblem;